module.exports = __webpack_public_path__ + "media/images/covers/PrepWorks_Student-Testimonial_Clarissa-Teh_Poster-22dec0e6855bdab8e96cfb96f68854a2.webp";